import { Alert } from "./services/components";
import login from "./login";
import {
  getSignupBillingType,
  DEFAULT_SELF_SERVE_TRIAL_TYPE,
  DIRECT_SIGNUP_PACKAGE_TYPES,
  getTrialTypeForSelectedPlan,
  getSignupHeading,
} from "./signupPlans";
import {
  stringLength,
  isEmail,
  isAlphabets,
  getLocalItem,
  setLocalItem,
  removeLocalItem,
  getLocalStorage,
} from "./services/utility";
import * as moment from "moment-timezone";
import ACApp, { ERROR_MSG } from "@tiktok-service/app-center-connect";
import {
  clearSignupAttribution,
  collectSignupAttribution,
  readGaClientId,
} from "./services/signupAttribution";
import {
  getCachedAffiliateIp,
  prefetchAffiliateIp,
} from "./services/affiliateIp";
import {
  msSincePageLoad,
  signinFailureReason,
  trackAuth,
} from "./services/authEvents";

const HOST_URL =
  typeof window !== "undefined" && window.__IS_WHITELABEL__
    ? window.location.origin
    : process.env.HOST_URL;
const URL = `${HOST_URL}/auth/local/`;
const SERVICE_URL = `${HOST_URL}/auth/appsumo/`;
const PASSWORD_LENGTH = 8;
// Longest a signup waits for the affiliate IP lookup that is still running.
const AFFILIATE_IP_WAIT_MS = 1000;

// Login experiment (z94kydcrz3): what this page showed, sent with sign-in and
// sign-up so the server can credit the success to the right arm. The server
// only trusts the arm when it matches its own assignment cookie.
const experimentHeaders = (form) => {
  const headers = {};
  const variant = typeof window !== "undefined" ? window.__LOGIN_VARIANT__ : "";
  // "none" when this page is not counted (control-only pages, previews of
  // control, experiment off), so the server never falls back to the cookie.
  headers["X-Login-Variant"] = variant || "none";
  headers["X-Login-Elapsed-Ms"] = String(msSincePageLoad() || 0);
  if (form && form.attr) {
    headers["X-Login-Remembered"] =
      form.attr("data-remembered-device") === "true" ? "1" : "0";
  }
  return headers;
};
// bcrypt hashes only the first 72 bytes; the API caps new passwords there
// (oauth/v1/localAuth/Validators.ts). Count UTF-8 bytes, not characters.
const PASSWORD_MAX_BYTES = 72;
const utf8Length = (value) => {
  try {
    return new TextEncoder().encode(value).length;
  } catch (e) {
    return unescape(encodeURIComponent(value)).length;
  }
};
console.log(window.NODE_ENV);
function AlertDiv(identifier) {
  this.id = identifier;
  this.ele = document.getElementById(identifier);
  this.textEle = document.querySelector(`#${identifier} .text`);
}

AlertDiv.prototype.clear = function () {
  this.ele.classList.add("d-none");
  this.ele.classList.remove("d-block");
  this.textEle.innerText = "";
};
AlertDiv.prototype.error = function (message) {
  this.ele.classList.add("d-block");
  this.ele.classList.add("alert-danger");
  this.ele.classList.remove("alert-success");
  this.ele.classList.remove("d-none");
  this.textEle.innerText = message;
};
/**
 * The same error banner, with one thing to DO about it.
 *
 * Some refusals are not the person's mistake and have an obvious next step:
 * an advocate who already has a login does not need to be told again that the
 * email is taken, they need the way in. A banner that only states the problem
 * leaves them retyping the form (86eyqu7pu 1/1).
 *
 * The link is BUILT, never interpolated into markup: the message travels from
 * the server and .error() deliberately uses innerText, so switching this one
 * banner to innerHTML would open the only hole on the page. Appending inside
 * .text also means clear() and the next error() wipe the link along with the
 * text, so a stale CTA cannot outlive the message it belonged to.
 */
AlertDiv.prototype.errorWithLink = function (message, label, href) {
  this.error(message);
  const link = document.createElement("a");
  link.href = href;
  link.className = "alert-link ml-1";
  link.innerText = label;
  this.textEle.appendChild(document.createTextNode(" "));
  this.textEle.appendChild(link);
};
AlertDiv.prototype.success = function (message) {
  this.ele.classList.add("d-block");
  this.ele.classList.add("alert-success");
  this.ele.classList.remove("alert-danger");
  this.ele.classList.remove("d-none");
  this.textEle.innerText = message;
};

function isValid(ele) {
  ele.valid = true;
  ele.classList.remove("is-invalid");
  ele.classList.add("is-valid");
  const helpText = ele.parentNode.querySelector(".help-block");
  if (helpText) {
    helpText.classList.add("d-none");
  }
}

function isInvalid(ele, alertEle, msg) {
  ele.valid = false;
  ele.classList.remove("is-valid");
  ele.classList.add("is-invalid");
  // ClickUp 86ey25qd4 - show the field's own .help-block, the same way the
  // blur handler already does (see onChange, which uses this exact selector,
  // so blur-time and submit-time feedback now agree). The message argument was
  // only ever passed to a commented-out alert, so every submit-time validation
  // failure was silent: the field turned red but said nothing, and on a zoomed
  // iOS viewport even the red border was off-screen.
  //
  // The fallback matters: this function is shared, and the LOGIN form has no
  // .help-block anywhere in its markup - it feeds #signin-alert instead.
  // Without the alert branch, login's two submit-time failures (invalid email,
  // short password) stay just as silent as before.
  const helpText = ele.parentNode.querySelector(".help-block");
  if (helpText) {
    helpText.classList.remove("d-none");
  } else if (alertEle && msg) {
    alertEle.error(msg);
  }
}

let isSigningIn = false;
let isTiktokAuth = false;
let isLoggedOut = false;

(function () {
  if (
    window.location.href.toLowerCase().includes("tiktokauth=true") ||
    getLocalItem("isTiktokAuth") === "true"
  ) {
    setLocalItem("isTiktokAuth", "true");
    isTiktokAuth = true;
  }

  if (window.location.href.toLowerCase().includes("loggedout=true")) {
    isLoggedOut = true;
    removeLocalItem("authToken");
  }

  const token = getLocalItem("authToken");
  if (token) {
    location.href = "https://app.socialchamp.com/";
  }
})();

function localAuthentication() {
  /**
   *
   * @description Login Triggers
   *
   */

  const loginTriggers = document.querySelectorAll(".login-btn");

  const getQueryVar = (type) => {
    let hash;
    const hashes = window.location.href
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");
    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      if (hash[0] === type) {
        return hash[1];
      }
    }
    return null;
  };

  const getQueryVarUtmCodes = () =>
    collectSignupAttribution({
      storage: getLocalStorage(),
      location: window.location,
      referrer: document.referrer,
      affiliateIp: getCachedAffiliateIp(),
    });

  const onLogin = function (evt) {
    evt.preventDefault();

    const type = this.getAttribute("data-type");
    let packageType = getQueryVar("package");
    let productType = getQueryVar("product");
    let couponCode = getQueryVar("couponCode");
    let lifetimeCode = getQueryVar("lifetimeCode");

    if (!DIRECT_SIGNUP_PACKAGE_TYPES.has(packageType)) {
      packageType = DEFAULT_SELF_SERVE_TRIAL_TYPE;
      productType = "PUBLISHER";
    }

    if (type) {
      login(type, false, productType, packageType, couponCode, lifetimeCode);
    }
  };

  function generateTimezones() {
    return moment.tz.names().map((timeZone, index) => {
      return {
        id: index,
        label: timeZone + ` (UTC${moment.tz(timeZone).format("Z")})`,
        name: timeZone,
        offset: "UTC" + moment.tz(timeZone).format("Z"),
        nOffset: moment.tz(timeZone).utcOffset(),
      };
    });
  }

  // Engaging inline loader shown in place of an auth form while the request
  // is in flight. It does not change the auth flow at all — it just keeps the
  // user company during the unavoidable wait, then hands off to redirect.
  // Reused for both signup and login (same look, different copy + element ids).
  function createSetupLoader(options) {
    const STEP_TITLES = options.steps;
    const TIPS = options.tips;
    const FINAL_TITLE = options.finalTitle || "You're all set!";

    let el;
    let formEl;
    let titleEl;
    let stepEls;
    let barEl;
    let tipEl;
    let stepTimer = null;
    let tipTimer = null;
    let current = -1;
    let finishing = false;
    let startedAt = 0;

    // Keep the loader on screen for at least this long, even if the request
    // comes back almost instantly, so it never just flashes and redirects.
    const MIN_VISIBLE_MS = 1600;

    function cache() {
      el = document.getElementById(options.loaderId);
      formEl = document.getElementById(options.formId);
      titleEl = el ? el.querySelector(".sc-signup-loader__title") : null;
      barEl = el ? el.querySelector(".sc-signup-loader__bar-fill") : null;
      tipEl = el ? el.querySelector(".sc-signup-loader__tip") : null;
      stepEls = el
        ? Array.from(el.querySelectorAll(".sc-signup-loader__step"))
        : [];
    }

    function swapTitle(text) {
      if (!titleEl) return;
      titleEl.classList.add("is-swapping");
      setTimeout(() => {
        titleEl.textContent = text;
        titleEl.classList.remove("is-swapping");
      }, 220);
    }

    // Move the checklist to `index`: everything before it is done, `index`
    // itself is the active (spinning) step. Progress eases toward 90% so it
    // never visually completes before the server actually responds.
    function gotoStep(index) {
      current = index;
      stepEls.forEach((step, i) => {
        step.classList.toggle("is-done", i < index);
        step.classList.toggle("is-active", i === index);
      });
      swapTitle(STEP_TITLES[index] || STEP_TITLES[STEP_TITLES.length - 1]);
      if (barEl) {
        const pct = Math.min(
          90,
          14 + index * (76 / Math.max(1, STEP_TITLES.length - 1)),
        );
        barEl.style.width = pct + "%";
      }
    }

    function nextTip() {
      if (!tipEl || !TIPS || !TIPS.length) return;
      const pick = TIPS[Math.floor(Math.random() * TIPS.length)];
      tipEl.classList.add("is-swapping");
      setTimeout(() => {
        tipEl.innerHTML = pick;
        tipEl.classList.remove("is-swapping");
      }, 400);
    }

    function start() {
      cache();
      if (!el) return;
      finishing = false;
      current = -1;
      startedAt = Date.now();

      // Swap the form out and reveal the loader in the same spot.
      if (formEl) formEl.classList.add("is-hidden");
      el.classList.add("is-active");
      el.setAttribute("aria-busy", "true");

      gotoStep(0);
      nextTip();

      // Auto-advance through the first steps, then hold on the last one until
      // the request resolves (finish() takes over from there).
      stepTimer = setInterval(() => {
        if (finishing) return;
        if (current < STEP_TITLES.length - 1) {
          gotoStep(current + 1);
        }
      }, 1500);

      tipTimer = setInterval(nextTip, 4200);
    }

    // Complete the checklist, fill the bar, then run the redirect callback.
    // Honors a minimum visible time so a fast response doesn't flash by.
    function finish(done) {
      const elapsed = Date.now() - startedAt;
      const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
      if (wait > 0) {
        setTimeout(() => finish(done), wait);
        return;
      }

      finishing = true;
      clearInterval(stepTimer);
      clearInterval(tipTimer);

      if (!el) {
        if (typeof done === "function") done();
        return;
      }

      stepEls.forEach((step) => {
        step.classList.add("is-done");
        step.classList.remove("is-active");
      });
      swapTitle(FINAL_TITLE);
      if (barEl) barEl.style.width = "100%";
      el.setAttribute("aria-busy", "false");

      setTimeout(() => {
        if (typeof done === "function") done();
      }, 900);
    }

    // Restore the form in place (used when the request fails).
    function hide() {
      finishing = true;
      clearInterval(stepTimer);
      clearInterval(tipTimer);
      if (el) {
        el.classList.remove("is-active");
        el.setAttribute("aria-busy", "false");
      }
      if (formEl) formEl.classList.remove("is-hidden");
    }

    return { start, finish, hide };
  }

  const SIGNUP_TIPS = [
    "<b>Did you know?</b><br>You can schedule a single post to 10+ social networks at once.",
    "<b>Pro tip:</b><br>Our AI Content Wizard can draft posts and captions for you.",
    "<b>Heads up:</b><br>The visual Content Calendar makes planning a whole month a breeze.",
    "<b>Good to know:</b><br>Connect your team and approve posts together in one place.",
    "<b>Fun fact:</b><br>Recycling your best posts keeps your feed active on autopilot.",
  ];

  const SignupLoader = createSetupLoader({
    loaderId: "signup-loader",
    formId: "form-signup",
    steps: [
      "Creating your account",
      "Setting up your workspace",
      "Personalizing your dashboard",
      "Activating your 14-day free trial",
      "Almost there",
    ],
    tips: SIGNUP_TIPS,
    finalTitle: "You're all set!",
  });

  const LoginLoader = createSetupLoader({
    loaderId: "login-loader",
    formId: "form-signin",
    steps: [
      "Verifying your credentials",
      "Loading your workspace",
      "Syncing your connected accounts",
      "Almost there",
    ],
    tips: SIGNUP_TIPS,
    finalTitle: "Welcome back!",
  });

  function signUp() {
    const urlParams = new URLSearchParams(window.location.search);
    // Warm the affiliate IP lookup while the visitor fills the form. signUp()
    // runs on every auth page, so only a page that has the signup form starts
    // the third-party lookup; login and password-reset pages never do.
    if (document.getElementById("form-signup")) {
      void prefetchAffiliateIp();
    }

    const signUpForm = $("#form-signup");
    const signUpBtn = $("#submit-signup");
    const timezone = moment.tz.guess();
    const timezones = generateTimezones();
    let currentTimezone = undefined;
    if (timezones.length) {
      currentTimezone = timezones.filter((zone) => zone.name === timezone)[0];
    }

    if (!currentTimezone) {
      currentTimezone = {
        timezoneName: "UTC",
        timezoneOffset: 0,
      };
    }

    if (!document.getElementById("form-signup")) {
      return;
    }

    const signupIntentOnLoad = (
      getQueryVar("signupIntent") ||
      getQueryVar("st") ||
      ""
    )
      .toString()
      .toUpperCase();
    if (signupIntentOnLoad === "PURCHASE") {
      const mainHeader = document.querySelector(".main-header");
      if (mainHeader) mainHeader.style.display = "none";
    }

    if (location.href.includes("/signup?success=true")) {
      $("#signup-success-modal").modal("show");
    }

    // $(() => {
    //   if (location.href.includes("/signup?success=true")) {
    //     $("#signup-success-modal").modal("show");
    //   }
    // });

    // const phoneFormControl = document.querySelector(
    //   "#form-signup input[name=phone]",
    // );
    // const iti = new window.intlTelInput(phoneFormControl, {});

    const name = document.querySelector("#form-signup input[name=name]");
    const email = document.querySelector("#form-signup input[name=email]");
    const password = document.querySelector(
      "#form-signup input[name=password]",
    );
    const confirmPassword = document.querySelector(
      "#form-signup input[name=confirmPassword]",
    );
    const _email = urlParams.get("email");
    if (_email) {
      email.value = _email;
    }

    // Heading reflects what this link leads to: trial links keep the trial
    // heading; offer links (Skip trial, coupon) and purchase-required or
    // non-trial links get their own. The rules live in getSignupHeading.
    (function setSignupHeading() {
      const heading = getSignupHeading(window.location.search);
      const titleEl = document.getElementById("signup-title");
      if (titleEl && heading) {
        titleEl.textContent = heading;
      }
    })();

    // Phase 1 revamp: live password-strength checklist + submit gating. The
    // "Sign up now" button stays disabled until name, email and all three
    // password rules pass, so the enabled button always leads to a valid submit.
    const passwordRulesEl = document.getElementById("pw-rules");
    // The control page caps the field at 20 with maxlength; the login
    // experiment pages (z94kydcrz3) drop maxlength so password managers work,
    // and the API accepts up to 72 bytes.
    const fieldMax =
      password && password.maxLength > 0 ? password.maxLength : 0;
    const PASSWORD_RULES = {
      length: (v) =>
        v.length >= PASSWORD_LENGTH &&
        (fieldMax ? v.length <= fieldMax : utf8Length(v) <= PASSWORD_MAX_BYTES),
      uppercase: (v) => /[A-Z]/.test(v),
      number: (v) => /\d/.test(v) || /[^A-Za-z0-9]/.test(v),
    };

    function evaluatePasswordRules() {
      const value = password ? password.value || "" : "";
      let allMet = true;
      if (passwordRulesEl) {
        passwordRulesEl.querySelectorAll(".pw-rule").forEach((item) => {
          const rule = PASSWORD_RULES[item.getAttribute("data-rule")];
          const met = rule ? rule(value) : false;
          item.classList.toggle("is-met", met);
          if (!met) {
            allMet = false;
          }
        });
      }
      return allMet;
    }

    function signupFormIsValid() {
      const nameOk = !!name && isAlphabets(name.value);
      const emailOk = !!email && !!isEmail(email.value);
      return nameOk && emailOk && evaluatePasswordRules();
    }

    function refreshSignupSubmitState() {
      signUpBtn.prop("disabled", !signupFormIsValid());
    }

    if (password) {
      const revealPasswordRules = () => {
        if (passwordRulesEl) {
          passwordRulesEl.classList.remove("d-none");
        }
      };
      password.addEventListener("focus", revealPasswordRules);
      password.addEventListener("input", () => {
        revealPasswordRules();
        evaluatePasswordRules();
        refreshSignupSubmitState();
      });
    }
    [name, email].forEach((field) => {
      if (field) {
        field.addEventListener("input", refreshSignupSubmitState);
      }
    });
    refreshSignupSubmitState();

    const onChange = (type) => {
      // ClickUp 86ey25qd4 - `required` is gone from the markup now, so the
      // removeAttribute calls that used to live here are dead. Worth recording
      // why they existed: they ran 1s after the FIRST blur, which is why the
      // honeypot only ever blocked a submit that happened inside that window -
      // a race, not a permanent block, and invisible because the field is
      // display:none ("An invalid form control with name='info' is not
      // focusable"). The value assignment stays: it is what the server logs.
      setTimeout(() => {
        document.querySelector(".info-field").value = 20;
      }, 1000);
      let field;
      let isValid = true;
      let isClear = false;
      if (type === "name") {
        field = name;
        if (!isAlphabets(name.value)) {
          isValid = false;
        }
      } else if (type === "email") {
        field = email;
        if (!isEmail(email.value)) {
          isValid = false;
        }
      } else if (type === "password") {
        field = password;
        if (!evaluatePasswordRules()) {
          isValid = false;
        }
      } else if (type === "confirmPassword") {
        field = confirmPassword;
        if (confirmPassword.value !== password.value) {
          isValid = false;
        }
      }

      // if(field.value === "") {
      //   return;
      // }

      const helpText = field.parentNode.querySelector(".help-block");
      if (isClear) {
        field.classList.remove("is-invalid");
        field.classList.remove("is-valid");
      } else if (isValid) {
        field.classList.remove("is-invalid");
        field.classList.add("is-valid");
        helpText && helpText.classList.add("d-none");
      } else {
        field.classList.remove("is-valid");
        field.classList.add("is-invalid");
        helpText && helpText.classList.remove("d-none");
      }
    };

    Array.from(signUpForm[0].querySelectorAll("input")).forEach((field) => {
      const type = field.getAttribute("name");
      field.addEventListener("blur", onChange.bind(null, type));
    });

    signUpForm.on("submit", async function (e) {
      e.preventDefault();
      // const phone = iti.getNumber();
      signUpBtn.prop("disabled", true);
      const form = $("#form-signup");
      const alert = new AlertDiv("signup-alert");
      const gaClientId = getGaClientIdFromCookie();

      // An autofilled, instant submit can beat the affiliate IP lookup. Give an
      // unfinished lookup a moment (it is already done almost every time and
      // never rejects), then go on without it: the server has a fallback.
      await Promise.race([
        prefetchAffiliateIp(),
        new Promise((resolve) => setTimeout(resolve, AFFILIATE_IP_WAIT_MS)),
      ]);

      let packageType = getQueryVar("package");
      const couponCode = getQueryVar("couponCode");
      const lifetimeCode = getQueryVar("lifetimeCode");
      const offerCode = getQueryVar("offerCode");
      let selectedPlan = getQueryVar("selectedPlan");
      const utmCode = getQueryVarUtmCodes();

      const postText = urlParams.get("text");
      const imageUrl = urlParams.get("imageUrl");

      let psxData = getLocalItem("psxData");
      try {
        psxData = JSON.parse(psxData);
      } catch (ex) {
        psxData = {};
      }
      let partnerStackId = null;
      if (psxData && psxData.psxId) {
        partnerStackId = psxData.psxId;
      }

      if (!DIRECT_SIGNUP_PACKAGE_TYPES.has(packageType)) {
        packageType = DEFAULT_SELF_SERVE_TRIAL_TYPE;
      }
      const selectedPlanTrialType = getTrialTypeForSelectedPlan(selectedPlan);
      if (selectedPlanTrialType) {
        packageType = selectedPlanTrialType;
      } else {
        selectedPlan = null;
      }

      name.valid = email.valid = password.valid = false;

      if (
        name.value.trim() === "" &&
        email.value.trim() === "" &&
        password.value.trim() === ""
      ) {
        alert.clear();
        alert.error("Please fill in all required fields.");
        signUpBtn.prop("disabled", false);
        return;
      }

      if (!isAlphabets(name.value)) {
        isInvalid(name, alert, "Name can only contain Alphabets");
        signUpBtn.prop("disabled", false);
        return;
      }

      isValid(name);

      if (!isEmail(email.value)) {
        isInvalid(email, alert, "Please enter a valid email address");
        signUpBtn.prop("disabled", false);
        return;
      }

      isValid(email);

      if (!evaluatePasswordRules()) {
        // ClickUp 86ey25qd4 - this branch returned with no feedback of any
        // kind: no isInvalid, no message. Reveal the rules checklist, which
        // evaluatePasswordRules has just marked up with is-met per rule.
        //
        // Deliberately NOT the .help-block here: its copy says "between 8 and
        // 20 characters", which contradicts the three live rules (8-20 chars,
        // one uppercase, one number or symbol) - a 10-character lowercase
        // password fails the rules while satisfying that sentence.
        if (passwordRulesEl) {
          passwordRulesEl.classList.remove("d-none");
        }
        password.classList.remove("is-valid");
        password.classList.add("is-invalid");
        signUpBtn.prop("disabled", false);
        return;
      }

      isValid(password);

      // if (confirmPassword.value !== password.value) {
      //   isInvalid(confirmPassword, alert, 'Confirm Password is not the same.');
      //   signUpBtn.prop('disabled', false);
      //   return;
      // }

      // isValid(confirmPassword);

      if (name.valid && email.valid && password.valid) {
        alert.clear();

        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("inviteToken");

        // Marketing "no free trial" link. When the signup URL carries the
        // purchase-required flag (e.g. /signup?signupIntent=PURCHASE or the
        // short alias /signup?st=purchase), suppress the default trial so the
        // user must buy a paid plan before using the app. Links without it
        // behave exactly as before.
        const signupIntentParam = (
          getQueryVar("signupIntent") ||
          getQueryVar("st") ||
          ""
        )
          .toString()
          .toUpperCase();
        const isPurchaseRequiredSignup = signupIntentParam === "PURCHASE";

        const payload = {
          name: name.value,
          email: email.value,
          password: password.value,
          trialType: packageType,
          billingType: getSignupBillingType(window.location.search),
          couponCode,
          lifetimeCode,
          offerCode,
          timezone: currentTimezone,
          utmCode,
          infoField: document.querySelector(".info-field").value,
          infoField1: document.querySelector(".info-field1").value,
          selectedPlan,
          post: {
            text: postText,
            image: imageUrl,
          },
        };

        if (isPurchaseRequiredSignup) {
          payload.signupIntent = "PURCHASE";
          const signupSource = getQueryVar("signupSource");
          if (signupSource) {
            payload.signupSource = String(signupSource).slice(0, 100);
          }
        }
        // if (phone && phone.trim()) {
        //   payload.phoneNumber = phone;
        // }

        if (token) {
          payload.teamInviteToken = token;
        }

        if (partnerStackId) {
          payload.psxId = partnerStackId;
        }

        // Kick off the engaging setup overlay for the duration of the request.
        SignupLoader.start();

        const req = $.ajax({
          url: `${URL}signup`,
          method: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          headers: {
            "app-type": "webapp",
            "GA-Client-Id": gaClientId || "",
            ...experimentHeaders(),
          },
        });

        req.done((res) => {
          if (res.status) {
            clearSignupAttribution(getLocalStorage());
            this.reset();
            form.find(".form-control").each((index, ele) => {
              ele.classList.remove("is-valid");
              ele.classList.remove("is-invalid");
            });

            // Capterra conversion code tracking
            window.trackingListener && window.trackingListener();
            initializeGoogleAnalytics(res.data);
            trackAuth("sign_up", { method: "email" });

            // Let the overlay finish its "all set!" beat, then redirect.
            SignupLoader.finish(() => {
              let routeToRedirect =
                location.origin + location.pathname + "?success=true";
              if (res.data && res.data.redirectUri) {
                if (!window.dataLayer) {
                  window.dataLayer = [];
                }
                window.dataLayer.push({
                  event: "user_signup",
                  packageType: packageType,
                  userId: res.data.userId,
                });
                location.href = res.data.redirectUri;
              } else {
                if (packageType) {
                  routeToRedirect += "&packageType=" + packageType;
                }
                if (res.data && res.data.userId) {
                  routeToRedirect += "&id=" + res.data.userId;
                }
                location.href = routeToRedirect;
              }
            });
          } else {
            SignupLoader.hide();
            trackAuth("sign_up_error", {
              method: "email",
              failure_reason: "other",
            });
            alert.error(res.message);
          }
        });

        req.fail((e) => {
          SignupLoader.hide();
          const error = (e.responseJSON && e.responseJSON.error) || {};
          trackAuth("sign_up_error", {
            method: "email",
            failure_reason: error.code
              ? String(error.code).toLowerCase()
              : signinFailureReason(e),
          });
          // An advocate already HAS this login; they simply never signed up
          // for Social Champ themselves, so the workspace setup they came for
          // is waiting behind it. The server says exactly that with a code
          // rather than the generic "account already exists"
          // (ACCOUNT_EXISTS_ADVOCATE, added alongside isAdvocateOnlyAccount),
          // and the only useful answer is a way to log in, not a form to
          // retype (86eyqu7pu 1/1).
          if (
            e.status === 409 &&
            error.code === "ACCOUNT_EXISTS_ADVOCATE" &&
            error.canLogIn
          ) {
            alert.errorWithLink(
              e.responseJSON.message ||
                "You already use this email for advocacy. Log in to set up your own workspace.",
              "Log in",
              "/login",
            );
            return;
          }
          alert.error(e.responseJSON.message);
        });

        req.always(() => {
          signUpBtn.prop("disabled", false);
        });
      }
    });
  }

  function initializeGoogleAnalytics(user) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: "signup_data",
      UserId: user.userId,
      Name: user.name,
      Email: user.email,
      CreatedAt: user.createdAt,
    });
  }

  async function signIn() {
    const signInBtn = $("#submit-signin");
    const signinForm = $("#form-signin");
    const urlParams = new URLSearchParams(window.location.search);
    let tiktokAuthToken = "";
    let app = "";
    try {
      app = new ACApp("7384574146409201682");
    } catch (ex) {
      app = null;
    }

    if (isTiktokAuth && !isLoggedOut) {
      try {
        const sessionToken = await app.getSessionToken();
        tiktokAuthToken = sessionToken;
        console.log(tiktokAuthToken);
        const req = jQuery.ajax({
          url: `${URL}verifyTiktokJwt`,
          method: "POST",
          data: JSON.stringify({
            token: tiktokAuthToken,
          }),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
        req.done((res) => {
          if (res.status) {
            if (res.token) {
              setLocalItem("authToken", res.token);
            }
            removeLocalItem("isTiktokAuth");
            location.href = res.data.redirectUri;
          } else {
            alert.error(e.message);
          }
        });
        req.fail((e) => {
          console.log(e);
        });
      } catch (e) {
        if (e.message === ERROR_MSG.getSessionToken.timeout) {
          // handle timeout error
          app.redirectToAuth("CMAPI");
        }
      }
    }

    if (signinForm) {
      signinForm.on("submit", async function (e) {
        e.preventDefault();
        if (isTiktokAuth) {
          const sessionToken = await app.getSessionToken();
          tiktokAuthToken = sessionToken;
        }

        // const form = document.getElementById("form-signin");
        const alert = new AlertDiv("signin-alert");
        const gaClientId = getGaClientIdFromCookie();
        const email = document.querySelector("#form-signin input[name=email]");
        const password = document.querySelector(
          "#form-signin input[name=password]",
        );
        signInBtn.prop("disabled", true);
        email.valid = password.valid = false;

        if (email.value === "" && password.value === "") {
          alert.clear();
          alert.error("Please fill the form");
          signInBtn.prop("disabled", false);
          trackAuth("login_failure", {
            method: "password",
            failure_reason: "empty_form",
          });
          return;
        }

        if (!isEmail(email.value)) {
          isInvalid(email, alert, "Please enter a valid email address");
          signInBtn.prop("disabled", false);
          trackAuth("login_failure", {
            method: "password",
            failure_reason: "invalid_email",
          });
          return;
        }

        isValid(email);

        // No upper bound: the sign-in API has none, and a 20-character cap
        // here rejected password-manager secrets before they reached it
        // (z94kydcrz3, PRD defect 6).
        if (password.value.length < PASSWORD_LENGTH) {
          isInvalid(password, alert, "Password must be at least 8 characters.");
          signInBtn.prop("disabled", false);
          trackAuth("login_failure", {
            method: "password",
            failure_reason: "short_password",
          });
          return;
        }

        isValid(password);

        alert.clear();
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("inviteToken");
        const redirectUrl = urlParams.get("redirectUrl");

        const couponCode = getQueryVar("couponCode");
        const lifetimeCode = getQueryVar("lifetimeCode");
        const offerCode = getQueryVar("offerCode");
        const selectedPlan = getQueryVar("selectedPlan");

        const postText = urlParams.get("text");
        const imageUrl = urlParams.get("imageUrl");

        const payload = {
          email: email.value,
          password: password.value,
          couponCode,
          lifetimeCode,
          offerCode,
          selectedPlan,
          post: {
            text: postText,
            image: imageUrl,
          },
        };

        if (tiktokAuthToken) {
          payload.tiktokAuthToken = tiktokAuthToken;
          payload.isTiktokAuth = true;
          payload.sendJWT = true;
        }
        if (token) {
          payload.teamInviteToken = token;
        }

        if (redirectUrl) {
          payload.redirectUrl = redirectUrl;
        }

        if (signinForm.attr("data-auth") === "true") {
          payload.sendJWT = true;
        }

        if (!isSigningIn) {
          isSigningIn = true;
          // Kick off the engaging inline loader for the duration of the request.
          LoginLoader.start();
          const req = jQuery.ajax({
            url: `${URL}signin`,
            method: "POST",
            data: JSON.stringify(payload),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
              "app-type": "webapp",
              "GA-Client-Id": gaClientId || "",
              ...experimentHeaders(signinForm),
            },
          });
          req.done((res) => {
            if (res.status) {
              this.reset();
              signinForm.find(".form-control").each((index, ele) => {
                ele.classList.remove("is-valid");
                ele.classList.remove("is-invalid");
              });

              removeLocalItem("isTiktokAuth");
              trackAuth("login_success", {
                method: "password",
                requires_2fa: !!res.requires2FA,
                time_to_auth_ms: msSincePageLoad(),
                // Logged in from the remembered-account chip without retyping
                // the email (PRD secondary metric). Set by login-v2.js; always
                // false on control, which has no chip.
                remembered_device:
                  signinForm.attr("data-remembered-device") === "true",
              });
              // Let the overlay finish its "welcome back" beat, then redirect.
              LoginLoader.finish(() => {
                location.href = res.data.redirectUri;
              });
            } else {
              LoginLoader.hide();
              // Was alert.error(e.message): `e` is not defined here, so this
              // branch threw instead of showing the server's message.
              alert.error(
                res.message || "Something went wrong. Please try again.",
              );
              trackAuth("login_failure", {
                method: "password",
                failure_reason: "other",
              });
            }
          });

          req.fail((e) => {
            LoginLoader.hide();
            trackAuth("login_failure", {
              method: "password",
              failure_reason: signinFailureReason(e),
            });
            if (
              e.responseJSON &&
              e.responseJSON.error &&
              e.responseJSON.error.isScheduledForDeletion
            ) {
              this.reset();
              signinForm.find(".form-control").each((index, ele) => {
                ele.classList.remove("is-valid");
                ele.classList.remove("is-invalid");
              });
              $("#forced-login")
                .attr("data-token", e.responseJSON.error.token)
                .removeAttr("data-continue");
              $("#delete-user-modal").modal("show");
            } else if (
              e.status === 409 &&
              e.responseJSON &&
              e.responseJSON.error &&
              e.responseJSON.error.code === "PASSWORD_NOT_SET"
            ) {
              alert.error(
                e.responseJSON.message ||
                  "This account was created with Google. Continue with Google.",
              );
              const googleButton = document.getElementById(
                "federated-google-button",
              );
              googleButton && googleButton.focus();
            } else if (
              e.status === 403 &&
              e.responseJSON &&
              e.responseJSON.error &&
              e.responseJSON.error.ssoEnforced
            ) {
              let errorMessage = e.responseJSON && e.responseJSON.message;
              if (!errorMessage) {
                errorMessage = "Please log in with SSO.";
              }
              alert.error(errorMessage);
            } else if (
              e.status === 403 &&
              e.responseJSON &&
              e.responseJSON.error &&
              e.responseJSON.error.token
            ) {
              this.reset();
              signinForm.find(".form-control").each((index, ele) => {
                ele.classList.remove("is-valid");
                ele.classList.remove("is-invalid");
              });
              $("#resend-email").attr("data-token", e.responseJSON.error.token);
              $("#in-active-user-modal").modal("show");
            } else {
              let errorMessage = e.responseJSON && e.responseJSON.message;
              if (!errorMessage) {
                errorMessage = "Uh oh! Looks like you are offline!";
              }
              alert.error(errorMessage);
            }
          });

          req.always(() => {
            isSigningIn = false;
            signInBtn.prop("disabled", false);
          });
        } else {
          alert.clear();
          alert.error("Your request is in process. Please wait.");
        }
      });
      // signinForm.removeEventListener("submit", signinFunc);
      // signinForm.addEventListener("submit", signinFunc);
    }

    const resendForm = $("#form-resend-confirmation-email");
    const forcedLogin = $("#form-forced-login");

    if (resendForm) {
      resendForm.on("submit", function (eve) {
        eve.preventDefault();
        const token =
          this.querySelector("#resend-email").getAttribute("data-token");
        if (!token) {
          return;
        }

        const payload = { token };

        const req = jQuery.ajax({
          url: `${URL}resendEmail`,
          method: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
        req.done((res) => {
          this.reset();
          Alert.success(res.message);
          $("#in-active-user-modal").modal("hide");
        });

        req.fail((e) => {
          if (e.responseJSON && e.responseJSON.message) {
            Alert.error(e.responseJSON.message);
          }
        });
      });
    }

    if (forcedLogin) {
      forcedLogin.on("submit", function (eve) {
        eve.preventDefault();
        const token =
          this.querySelector("#forced-login").getAttribute("data-token");
        if (!token) {
          return;
        }
        const continueWithGoogle =
          this.querySelector("#forced-login").getAttribute("data-continue") ===
          "google";

        const payload = { token };

        const req = jQuery.ajax({
          url: `${URL}reactivate`,
          method: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
        req.done((res) => {
          Alert.success("Your account has been reactivated.");
          if (continueWithGoogle) {
            // They arrived through Google, which was just verified: the server
            // finishes that sign-in from its session, no second Google trip.
            $("#delete-user-modal").modal("hide");
            location.href = "/oauth/v1/federated/google/reactivated";
            return;
          }
          if (res.data && res.data.redirectUri) {
            location.href = res.data.redirectUri;
          }
          $("#delete-user-modal").modal("hide");
        });

        req.fail((e) => {
          if (e.responseJSON && e.responseJSON.message) {
            Alert.error(e.responseJSON.message);
          }
        });
      });
    }

    // Surface the outcome of /auth/local/verify, which redirects here with a
    // ?verified= flag instead of rendering the old account-verified page.
    if (signinForm.length) {
      const search = new URLSearchParams(window.location.search);
      const verified = search.get("verified");

      // Each banner has a default message (for logged-out visitors, who then
      // log in) and an authText variant used when the visitor is already
      // signed in — the "log in / resend" call-to-action would be contradictory
      // there, since the continue block below handles their next step.
      const VERIFY_BANNERS = {
        success: {
          type: "success",
          icon: "fa-check-circle",
          text: "Your email is verified. Log in to continue.",
          authText: "Your email is verified.",
        },
        already: {
          type: "info",
          icon: "fa-info-circle",
          text: "Your email is already verified. Log in below.",
          authText: "Your email is already verified.",
        },
        expired: {
          type: "error",
          icon: "fa-exclamation-triangle",
          text: "This verification link has expired. Log in to resend a new one.",
          authText: "This verification link has expired.",
        },
        invalid: {
          type: "error",
          icon: "fa-exclamation-triangle",
          text: "This verification link is invalid. Log in or resend the verification email.",
          authText: "This verification link is invalid.",
        },
        error: {
          type: "error",
          icon: "fa-exclamation-triangle",
          text: "We couldn't verify your email. Log in or resend the verification email.",
          authText: "We couldn't verify your email.",
        },
      };

      const VERIFY_BANNER_PALETTE = {
        success: { bg: "#EAF6EC", border: "#BBE2C2", text: "#1B7A34" },
        info: { bg: "#E7F1FB", border: "#BAD6F1", text: "#14599E" },
        error: { bg: "#FDECEC", border: "#F3C6C6", text: "#B42318" },
      };

      const renderVerifyBanner = (cfg, authenticated) => {
        const palette = VERIFY_BANNER_PALETTE[cfg.type];
        // The form's own container: .login-form on control, .lv2-body on the
        // login-experiment arms (z94kydcrz3), which have no .login-form.
        const form = document.getElementById("form-signin");
        const host = form && form.parentNode;
        if (!palette || !host || !form) {
          return;
        }
        const text = authenticated && cfg.authText ? cfg.authText : cfg.text;
        const el = document.createElement("div");
        el.id = "verify-banner";
        el.setAttribute("role", "status");
        Object.assign(el.style, {
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          padding: "10px 12px",
          marginBottom: "16px",
          borderRadius: "8px",
          fontSize: "13px",
          lineHeight: "1.5",
          border: `1px solid ${palette.border}`,
          background: palette.bg,
          color: palette.text,
        });
        el.innerHTML = `<i class="fas ${cfg.icon}" aria-hidden="true" style="margin-top:2px;font-size:15px;"></i><span>${text}</span>`;
        host.insertBefore(el, form);
      };

      const renderAuthenticatedVerificationContinue = () => {
        const form = document.getElementById("form-signin");
        const host = form && form.parentNode;
        if (!host || !form) {
          return;
        }
        form.style.display = "none";
        const el = document.createElement("div");
        el.id = "verify-banner-continue";
        el.style.marginBottom = "16px";
        const message = document.createElement("p");
        message.textContent = "You are already signed in.";
        message.style.marginBottom = "12px";
        const link = document.createElement("a");
        link.href = "/auth/verify2FA";
        link.className = "btn btn-primary btn-block text-capitalize";
        link.textContent = "Continue to Social Champ";
        el.append(message, link);
        host.insertBefore(el, form);
      };

      const banner = VERIFY_BANNERS[verified];
      if (banner) {
        const authenticated = search.get("verifiedSession") === "1";
        renderVerifyBanner(banner, authenticated);
        if (authenticated) {
          renderAuthenticatedVerificationContinue();
        }
      }

      if (verified) {
        search.delete("verified");
        search.delete("token");
        search.delete("verifiedSession");
        const query = search.toString();
        window.history.replaceState(
          {},
          document.title,
          `${window.location.pathname}${query ? `?${query}` : ""}${
            window.location.hash
          }`,
        );
      }
    }
  }

  function forgotPassword() {
    const form = document.getElementById("form-forgot-password");
    const forgotBtn = $("#submit-forgot");
    const alert = new AlertDiv("forget-alert");

    if (!form) {
      return;
    }
    form.addEventListener("submit", (evt) => {
      evt.preventDefault();
      alert.clear();

      const email = document.querySelector(
        "#form-forgot-password input[name=email]",
      );
      forgotBtn.prop("disabled", true);
      email.valid = false;
      if (!isEmail(email.value)) {
        isInvalid(email, alert, "Please enter a valid email address");
        // Without this the button stayed disabled after a typo, so the
        // corrected address could not be sent without reloading.
        forgotBtn.prop("disabled", false);
        return;
      }

      email.valid = true;
      email.classList.remove("is-invalid");
      email.classList.add("is-valid");

      const payload = {};
      payload.email = email.value;
      const req = jQuery.ajax({
        url: `${URL}forgotPassword`,
        method: "POST",
        data: JSON.stringify(payload),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      });
      req.done((res) => {
        if (res.status) {
          trackAuth("password_reset_requested", {});
          form.reset();
          email.classList.remove("is-valid");
          alert.success(res.message);
        } else {
          alert.error(res.message);
        }
      });

      req.fail((res) => {
        if (res.responseJSON && res.responseJSON.message) {
          alert.error(res.responseJSON.message);
        }
      });

      req.always(() => {
        forgotBtn.prop("disabled", false);
      });
    });
  }

  function resetPassword() {
    const resetPasswordForm = document.getElementById("form-reset-password");
    const resetBtn = $("#submit-reset");
    if (!resetPasswordForm) {
      return;
    }

    const params = new URLSearchParams(
      window.location.hash.slice(1) || window.location.search,
    );
    // Capture privately before removing credentials and UI state from history.
    const cleanUrl = new window.URL(window.location.href);
    for (const key of ["token", "status", "title", "message"])
      cleanUrl.searchParams.delete(key);
    cleanUrl.hash = "";
    window.history.replaceState(null, "", cleanUrl.pathname + cleanUrl.search);
    const tokenFromQuery = params.get("token");
    const status = params.get("status");
    const stateWrap = document.getElementById("reset-password-state");
    const stateTitle = document.getElementById("reset-password-state-title");
    const stateMessage = document.getElementById(
      "reset-password-state-message",
    );
    const formWrap = document.getElementById("reset-password-form-wrap");
    const stateActions = document.getElementById(
      "reset-password-state-actions",
    );
    const getLocalePathPrefix = () =>
      /^\/ar(\/|$)/.test(window.location.pathname) ? "/ar" : "";
    const tokenInput = document.querySelector(
      "#form-reset-password input[name=token]",
    );

    if (tokenInput && tokenFromQuery) {
      tokenInput.value = tokenFromQuery;
    }

    const isValidResetLink = !status || status === "valid";

    if (!tokenFromQuery || !isValidResetLink) {
      const defaultTitle = "Reset Link Unavailable";
      const defaultMessage =
        "This reset password link is invalid or has expired. Please request a new one.";

      const title = params.get("title") || defaultTitle;
      const message = params.get("message") || defaultMessage;

      if (formWrap) {
        formWrap.classList.add("d-none");
      }
      if (stateTitle) {
        stateTitle.textContent = title;
      }
      if (stateMessage) {
        stateMessage.textContent = message;
      }
      if (stateWrap) {
        stateWrap.classList.remove("d-none");
      }
      // Without this the page is a dead end: the form is hidden and the only
      // remaining control is the browser's Back button (ClickUp 86ex9umd2).
      if (stateActions) {
        // The landing routes are /:lang(ar)?/:pathName, so an Arabic visitor is
        // on /ar/reset-password. Root-relative hrefs keep a white-label tenant
        // on its own host (which is why they are not absolute) but they also
        // drop the locale segment, which would bounce an ar visitor into the
        // English page. Carry the prefix through.
        const localePrefix = getLocalePathPrefix();
        if (localePrefix) {
          stateActions.querySelectorAll("a[href^='/']").forEach((anchor) => {
            anchor.setAttribute(
              "href",
              localePrefix + anchor.getAttribute("href"),
            );
          });
        }
        stateActions.classList.remove("d-none");
      }
      return;
    }

    if (stateWrap) {
      stateWrap.classList.add("d-none");
    }
    if (formWrap) {
      formWrap.classList.remove("d-none");
    }

    resetPasswordForm.addEventListener("submit", (eve) => {
      eve.preventDefault();

      const password = document.querySelector(
        "#form-reset-password input[name=password]",
      );
      const confirmPassword = document.querySelector(
        "#form-reset-password input[name=confirmPassword]",
      );
      const token = document.querySelector(
        "#form-reset-password input[name=token]",
      );

      resetBtn.prop("disabled", true);

      password.valid = confirmPassword.valid = token.valid = false;

      // Same limit as sign-up, so an account can reset to a password as long
      // as the one it was created with (z94kydcrz3).
      if (
        password.value.length < PASSWORD_LENGTH ||
        utf8Length(password.value) > PASSWORD_MAX_BYTES
      ) {
        password.classList.add("is-invalid");
        password.valid = false;
        Alert.error(
          password.value.length < PASSWORD_LENGTH
            ? "Password must be at least 8 characters."
            : "Password is too long. Use up to 72 characters, fewer if it has emoji or non-Latin letters.",
        );
        resetBtn.prop("disabled", false);
        return;
      }

      password.classList.remove("is-invalid");
      password.classList.add("is-valid");
      password.valid = true;

      if (confirmPassword.value !== password.value) {
        confirmPassword.classList.add("is-invalid");
        confirmPassword.valid = false;
        Alert.error("Password and Confirm Password do not match");
        resetBtn.prop("disabled", false);
        return;
      }

      confirmPassword.classList.remove("is-invalid");
      confirmPassword.classList.add("is-valid");
      confirmPassword.valid = true;

      if (!token.value) {
        Alert.error(
          "This reset link is incomplete. Please use the link from your email, or request a new one.",
        );
        resetBtn.prop("disabled", false);
        return;
      }

      token.valid = true;

      const payload = {};
      payload.password = password.value;
      payload.confirmPassword = confirmPassword.value;
      payload.token = token.value;

      const req = jQuery.ajax({
        url: `${URL}resetPassword`,
        method: "POST",
        data: JSON.stringify(payload),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
      });
      req.done((res) => {
        if (res.status) {
          resetPasswordForm.reset();
          $("#form-reset-password")
            .find(".form-control")
            .each((index, ele) => {
              ele.classList.remove("is-valid");
              ele.classList.remove("is-invalid");
            });
          $("#left .login-form .main-header").addClass("d-none");
          $("#reset-password-form-wrap").html("");
          const successHTML =
            '<h4 class="title mb-2">Password updated</h4><p class="subTitleHead mb-4">Your password has been changed successfully. You can now log in using your new password.</p><a href="' +
            getLocalePathPrefix() +
            '/login" class="btn btn-primary btn-block text-capitalize">Go to Login</a>';
          $("#reset-password-success-wrap").html(successHTML);
          resetBtn.prop("disabled", false);
        }
      });

      req.fail((res) => {
        resetBtn.prop("disabled", false);
        // A non-JSON error response - an ALB 502, a proxy error page - has no
        // responseJSON, and reading .message off it threw, so the user got no
        // message at all. The same dead end this card is about, one layer down.
        Alert.error(
          (res.responseJSON && res.responseJSON.message) ||
            "Something went wrong. Please request a new reset link and try again.",
        );
      });

      req.always(() => {
        resetBtn.prop("disabled", false);
      });
    });
  }

  function continueAuth() {
    const continueBtn = document.getElementById("continue-logged-in");

    continueBtn &&
      continueBtn.addEventListener("click", (eve) => {
        eve.preventDefault();
        const alert = new AlertDiv("signin-alert");
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("inviteToken");

        if (!token) {
          alert.error("No team invite token found");
          return;
        }

        const payload = { teamInviteToken: token };

        const req = $.ajax({
          url: "/auth/team/continueLoggedIn",
          method: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        }).done((res) => {
          if (res.status) {
            window.location.href = res.redirectUri;
          }
        });

        req.fail((e) => {
          if (e.responseJSON && e.responseJSON.message) {
            // Alert.error(e.responseJSON.message);
            alert.error(e.responseJSON.message);
          }
        });
      });
  }

  function clientUserFirstLogin() {
    const loginForm = document.getElementById("form-client-first-login");
    const submitBtn = $("#client-first-login");
    loginForm &&
      loginForm.addEventListener("submit", function (eve) {
        eve.preventDefault();

        const name = document.querySelector(
          "#form-client-first-login input[name=name]",
        );
        const password = document.querySelector(
          "#form-client-first-login input[name=password]",
        );
        const confirmPassword = document.querySelector(
          "#form-client-first-login input[name=confirmPassword]",
        );

        const token = document.querySelector(
          "#form-client-first-login input[name=token]",
        );

        submitBtn.prop("disabled", true);
        name.valid =
          password.valid =
          confirmPassword.valid =
          token.valid =
            false;

        if (!name || !name.value || !name.value.trim()) {
          name.classList.add("is-invalid");
          name.valid = false;
          Alert.error("Name is required");
          submitBtn.prop("disabled", false);
          return;
        }

        name.classList.remove("is-invalid");
        name.classList.add("is-valid");
        name.valid = true;

        if (
          password.value.length < PASSWORD_LENGTH ||
          password.value.length > 20
        ) {
          password.classList.add("is-invalid");
          password.valid = false;
          Alert.error("Password must be between 8 and 20 characters");
          submitBtn.prop("disabled", false);
          return;
        }

        password.classList.remove("is-invalid");
        password.classList.add("is-valid");
        password.valid = true;

        if (confirmPassword.value !== password.value) {
          confirmPassword.classList.add("is-invalid");
          confirmPassword.valid = false;
          Alert.error("Password and Confirm Password do not match");
          submitBtn.prop("disabled", false);
          return;
        }

        confirmPassword.classList.remove("is-invalid");
        confirmPassword.classList.add("is-valid");
        confirmPassword.valid = true;

        if (!token.value) {
          Alert.error(
            "This reset link is incomplete. Please use the link from your email, or request a new one.",
          );
          submitBtn.prop("disabled", false);
          return;
        }

        token.valid = true;

        const payload = {};
        payload.name = name.value;
        payload.password = password.value;
        payload.confirmPassword = confirmPassword.value;
        payload.token = token.value;

        const req = jQuery.ajax({
          url: `${SERVICE_URL}postSignup`,
          method: "POST",
          data: JSON.stringify(payload),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
        req.done((res) => {
          if (res.status) {
            location.href = res.data.redirectUri;
            loginForm.reset();
            $("#form-client-first-login")
              .find(".form-control")
              .each((index, ele) => {
                ele.classList.remove("is-valid");
                ele.classList.remove("is-invalid");
              });
            $("#form-client-first-login-wrap").html("");
            $("#success-signin-form").removeClass("d-none");
            submitBtn.prop("disabled", false);
          }
        });
        req.fail((res) => {
          submitBtn.prop("disabled", false);
          Alert.error(res.responseJSON.message);
        });
        req.always(function () {
          submitBtn.prop("disabled", false);
        });
      });
  }

  const redirectSignUp = () => {
    const index = window.location.href.indexOf("?");
    let queryParams = "";
    if (index > 0) {
      queryParams = window.location.href.slice(index);
    }
    location.href = `/signup${queryParams || ""}`;
  };
  const redirectTeamSignUp = () => {
    const index = window.location.href.indexOf("?");
    let queryParams = "";
    if (index > 0) {
      queryParams = window.location.href.slice(index);
    }
    location.href = `/auth/team/signup${queryParams || ""}`;
  };

  const redirectSignIn = () => {
    const index = window.location.href.indexOf("?");
    let queryParams = "";
    if (index > 0) {
      queryParams = window.location.href.slice(index);
    }
    location.href = `/login${queryParams || ""}`;
  };
  const redirectTeamSignIn = () => {
    const index = window.location.href.indexOf("?");
    let queryParams = "";
    if (index > 0) {
      queryParams = window.location.href.slice(index);
    }
    location.href = `/auth/team/login${queryParams || ""}`;
  };

  const redirectForgotPass = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const index = window.location.href.indexOf("?");
    let queryParams = "";
    if (index > 0) {
      queryParams = window.location.href.slice(index);
    }
    location.href = `/forgot-password${queryParams || ""}`;
  };

  const getGaClientIdFromCookie = () => readGaClientId(document.cookie);

  $(function () {
    document.querySelectorAll(".signup-btn").forEach((signup) => {
      signup.addEventListener("click", redirectSignUp);
    });
    document.querySelectorAll(".team-signup-btn").forEach((signup) => {
      signup.addEventListener("click", redirectTeamSignUp);
    });
    document.querySelectorAll(".create-an-account-btn").forEach((signup) => {
      signup.addEventListener("click", redirectSignUp);
    });
    document.querySelectorAll(".forgot-password").forEach((element) => {
      element.addEventListener("click", redirectForgotPass);
    });
    document
      .querySelectorAll(".create-team-an-account-btn")
      .forEach((signup) => {
        signup.addEventListener("click", redirectTeamSignUp);
      });

    document.querySelectorAll(".signin-btn").forEach((signin) => {
      signin.addEventListener("click", redirectSignIn);
    });
    document.querySelectorAll(".team-signin-btn").forEach((signin) => {
      signin.addEventListener("click", redirectTeamSignIn);
    });

    loginTriggers.forEach((btn) => {
      btn.addEventListener("click", onLogin);
    });

    if (document.querySelector("#form-signin input[name=email]")) {
      document
        .querySelector("#form-signin input[name=email]")
        .addEventListener("blur", function (e) {
          this.value = this.value.trim();
        });
    }
    if (document.querySelector("#form-signup input[name=email]")) {
      document
        .querySelector("#form-signup input[name=email]")
        .addEventListener("blur", function (e) {
          this.value = this.value.trim();
        });
    }
    if (document.querySelector("#form-forgot-password input[name=email]")) {
      document
        .querySelector("#form-forgot-password input[name=email]")
        .addEventListener("blur", function (e) {
          this.value = this.value.trim();
        });
    }

    if (
      document.querySelector("#form-signin input[name=password]") ||
      document.querySelector("#form-signup input[name=password]")
    ) {
      const eyeIcon = document.querySelector("#eye");
      const passwordField = document.querySelector("#password");

      if (eyeIcon && passwordField) {
        eyeIcon.addEventListener("click", function () {
          const isPasswordVisible =
            passwordField.getAttribute("type") === "text";

          // Toggle password type
          passwordField.setAttribute(
            "type",
            isPasswordVisible ? "password" : "text",
          );

          // Toggle image source
          eyeIcon.src = isPasswordVisible
            ? "/assets/images/eye-close.svg" // Hide password (eye-off)
            : "/assets/images/eye-open.svg"; // Show password (eye-on)
        });
      }
    }

    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    if (error) {
      const alert = new AlertDiv("signin-alert");
      if (window.location.pathname.includes("login")) {
        alert.error(error);
      }
    }

    signUp();
    signIn();
    forgotPassword();
    resetPassword();
    continueAuth();
    clientUserFirstLogin();
  });
}

export default localAuthentication;
